let _ = require('lodash');
let treeHelper = require('../../helpers/tree');
let { clearFilter } = require('./filterable-tree');

const CITIES_TREE_BASE_PATH = ['order', 'cities', 'tree'];
const CITIES_ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'cities'];

module.exports = {
    recalculateFlags,

    initTreeState (args, state) {
        treeHelper.initTreeUiState(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH);
    },

    changeValue ({ path, value }, state) {
        treeHelper.changeTreeNodeValue(
            state,
            CITIES_ORIGINAL_DATA_PATH,
            CITIES_TREE_BASE_PATH,
            path,
            value);

        recalculateFlags(state);
    },

    changeBranchSelection ({ value, branchId }, state) {
        treeHelper.selectBranch(
            state,
            CITIES_ORIGINAL_DATA_PATH,
            CITIES_TREE_BASE_PATH,
            value,
            branchId);

        recalculateFlags(state);
    },

    setSelection ({ value, filter }, state) {
        treeHelper.setValueByFilter(
            state,
            CITIES_ORIGINAL_DATA_PATH,
            CITIES_TREE_BASE_PATH,
            value,
            filter);

        recalculateFlags(state);
    },

    setAll ({ value }, state) {
        treeHelper.setAllSelection(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH, value);
        recalculateFlags(state);
    },

    toggleFilterType (args, state) {
        let path = CITIES_TREE_BASE_PATH.concat('showFilterTreeInput');
        let value = state.get(path) || false;

        // показываем/прячем фильтр по списку
        state.set(path, !value);

        // прячем/показываем обычный фильтр
        state.set(CITIES_TREE_BASE_PATH.concat('hideFilter'), !value);
    },

    clearFilter (args, state) {
        treeHelper.clearFilter(state, CITIES_TREE_BASE_PATH, 'cities');
        recalculateFlags(state);
    },

    localSaveMapFilter(args, state) {
        let mapFilter = state.get(['order', 'cities', 'mapFilter']);
        if (mapFilter) {
            state.set(['order', 'cities', 'mapFilterInit'], mapFilter);
        }
    },

    initMapFilter({ selectedParameters }, state) {
        if (selectedParameters) {
            state.set(['order', 'cities', 'mapFilterInit'], selectedParameters.mapFilter);
        }
    },

    /***
     * Эта функция создаёт фильтр, который позволит перенести данные из дерева Городов в дерево Проектов
     * Если дефолтный город проекта выбран в дереве городов, то проект будет выбран в дереве проектов
     * Все остальные города игнорируются
     * @param args
     * @param state
     */
    getBranchesTreeFilter (args, state) {
        let leafs = state.get(CITIES_TREE_BASE_PATH.concat('computed', 'leafs'));
        let selected = state.get(CITIES_TREE_BASE_PATH.concat('selected'));
        let selectedCities = treeHelper.getSelectedLeafs(leafs, selected);
        let defaultCities = _.filter(state.get(CITIES_ORIGINAL_DATA_PATH), { isDefaultCity: true });
        let selectedBranches = _.map(_.filter(defaultCities, city => selectedCities.includes(city.code)), x => x.branchId);
        args.filter = node => {
            return selectedBranches.includes(Number(node.code));
        };
    },
};

/**
 * Ищем в дереве отмеченные русские и нерусские элементы, выставляем соответсвующие флаги
 * @param state
 */
function recalculateFlags (state) {
    let selected = state.get(CITIES_TREE_BASE_PATH.concat('selected'));
    let original = state.get(CITIES_ORIGINAL_DATA_PATH);
    let hasRussian = false;
    let hasNonRussian = false;
    _.forEach(selected, function(item, key) {
        if (item.value === false || key === '0') {
            return;
        }
        if (original[key].isRussian === true) {
            hasRussian = true;
            return false;
        }
    });
    _.forEach(selected, function(item, key) {
        if (item.value === false || key === '0') {
            return;
        }
        if (original[key].isRussian === false) {
            hasNonRussian = true;
            return false;
        }
    });

    if (hasRussian === true) {
        state.set(CITIES_TREE_BASE_PATH.concat('hasRussians'), true);
    } else {
        state.unset(CITIES_TREE_BASE_PATH.concat('hasRussians'));
    }

    if (hasNonRussian === true) {
        state.set(CITIES_TREE_BASE_PATH.concat('hasNonRussians'), true);
    } else {
        state.unset(CITIES_TREE_BASE_PATH.concat('hasNonRussians'));
    }
}




// WEBPACK FOOTER //
// ./actions/custom-order/cities.js